/**
 * Shared field names + tuning constants for the anti-spam layers.
 *
 * This module is intentionally dependency-free (no Node built-ins) so it can be
 * imported from BOTH client components and server route handlers. Keep it that
 * way — the actual enforcement lives in `spam-guard.ts` (server only).
 */

/** Honeypot input name. Hidden from humans; bots that fill it are dropped. */
export const HONEYPOT_FIELD = 'company_url'

/** Signed render-time token used for the submission-timing check. */
export const FORM_TOKEN_FIELD = 'form_token'

/** Cloudflare Turnstile response token. */
export const CAPTCHA_FIELD = 'captcha_token'

/** Minimum plausible time (ms) between form render and a human submit. */
export const MIN_SUBMIT_MS = 3000

/** Max lifetime (ms) of a timing token before it must be re-fetched. */
export const TOKEN_MAX_AGE_MS = 60 * 60 * 1000
